<script>
// import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import axios from "axios";
import moment from "moment";
import "vue-select/dist/vue-select.css";
import Vuetable from "vuetable-2";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
// Lets Register a Global Error Notification Toast.
/**
 * Departamento component
 */
export default {
  page: {
    title: "Información de la orden de compra",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, Vuetable },
  data() {
    return {
      stock: [],
      url: 0,

      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      formPro: {
        fecha_orde: "",
        direccionp: "",
        empleado: "",
        nit_proveedor: "",
        observaciones: "",
        no_orden: "",
        fecha_compra: "",
        tienda: "",
        proveedor: "",
        total: "",
        state: true,
        id: 0,
      },
      detalleorden: [],
      fields: [
        {
          name: "stock.producto.nombre_producto",
          sortField: "stock.producto.nombre_producto",
          title: "Nombre",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "25%",
        },
        {
          name: "presentaciones",
          sortField: "presentaciones",
          title: "Presentación",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "25%",
        },
        {
          name: "cantidad_compra",
          sortField: "cantidad_compra",
          title: "Cantidad",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "25%",
        },
        {
          name: "precio_compra",
          sortField: "precio_compra",
          title: "Precio Compra",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "25%",
        },

        {
          name: "subtotal",
          sortField: "subtotal",
          title: "Subtotal",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "25%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          width: "20%",
        },
      ],
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
      },
      formget: {
        nombre: "",
        state: true,
      },
      formSub: {
        nombre: "",
        cantidaddepa: "",
        state: true,
        id: 0,
      },
      updating: false,
      title: "Información",
      itemst: [
        {
          text: "Orden de compra",
          href: "/compras/ordendecompra",
        },
        {
          text: "Información",
          active: true,
        },
      ],
      loadingtable: false,

      showModalL: false, //Loading
      showModalE: false, //Editar
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      data: [],
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      // axios({
      //   baseURL: this.apiUrl + "auth/checkToken",
      //   method: "POST",
      //   headers: { "x-token": usuario.token },
      // })
      //   .then((res) => {
      //     if (res.data.success) {
      //       // this.$router.push("/");
      //     }
      //   })
      //   .catch(() => {
      //     this.logout();
      //     location.reload();
      //   });
    }
    this.detalle();
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMM Do YYYY");
    },
    detalle() {
      axios
        .get(
          process.env.VUE_APP_URL +
            "ordenes/view_orden?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          this.detalleorden = response.data.orden.detalle_ordens;
          this.formPro.empleado =
            response.data.orden.user.empleado.persona.nombre_persona +
            " " +
            response.data.orden.user.empleado.persona.apellido_persona;
          this.formPro.nit_proveedo =
            response.data.orden.proveedore.nit_proveedor;
          this.formPro.proveedor =
            response.data.orden.proveedore.company_proveedor;
          this.formPro.no_orden = response.data.orden.no_orden;
          this.formPro.observaciones = response.data.orden.observaciones;
          this.formPro.fecha_compra = this.showDate(
            response.data.orden.fecha_compra
          );
          this.formPro.fecha_orden = this.showDate(
            response.data.orden.fecha_orden
          );
          this.formPro.total = response.data.orden.total;
          this.formPro.user = response.data.orden.usuario_autoriza?.usuario;
          this.formPro.direccionp =
            response.data.orden.proveedore.direccion_proveedor;
          this.formPro.state = response.data.orden.estado_orden;
          //  console.log( response.data.orden)
        });
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <b-modal
          centered
          v-model="showModalL"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
          no-close-on-backdrop
          content-class="my-class"
          header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                    :animation-duration="2000"
                    :size="90"
                    color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Activar -->

        <!-- Modal para Desactivar -->
        <!--             <b-modal
              centered
              v-model="showModalD"
              title="Desactivar"
              title-class="text-black font-18"
              body-class="p-3"
              hide-footer
                  >
                    <form>
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            
                         <h4>¿Desea Desactivar  {{this.formSub.nombre}}?</h4>
                            
                          </div>
                        </div>
                      
                       
                      </div>
                      <div class="text-end pt-5 mt-3">
                        <b-button variant="light" @click="showModalD = false">Cancelar</b-button>
                         <b-button variant="danger" @click="desactivate">Desactivar</b-button>
                      </div>
                    </form>
            </b-modal>
 -->

        <div class="card" style="margin-bottom: 0%;">
          <div class="card-body" style="padding: 0%;">
            <div class="">
              <div class="row justify-content-center">
                <div class="col">
                  <div class="row">
                    <div class="col">
                        <div>
                          <router-link
                            :to="{
                              name: 'ordendecompra',
                            }"
                          >
                            <b-button
                              variant="outline-primary"
                              type="button"
                              class="btn btn-rounded mb-2 me-2"
                            >
                              <i class="mdi mdi-arrow-collapse-left"></i>
                              Regresar
                            </b-button>
                          </router-link>
                        </div>
                      </div>
                  <div class="col text-center">
                    <h4>Orden de Compra</h4>
                  </div>
                  <div class="col">
                    <a href="#" class="badge bg-dark font-size-12">
                      <i
                        class="bx bx-purchase-tag-alt align-middle text-muted me-1"
                      ></i>
                      Fecha Orden: {{ formPro.fecha_compra }}
                    </a>
                  </div>
                </div>
                <hr />
                  <div class="text-center">
                    <div class="row">
                      <div class="col-sm-3">
                        <div>
                          <p class="text-muted ">Dirección</p>
                          <h5 class="font-size-15">{{ formPro.direccionp }}</h5>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div>
                          <p class="text-muted ">Observaciones</p>
                          <h5 class="font-size-15">
                            {{ formPro.observaciones }}
                          </h5>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted ">Estado</p>
                          <h5 v-if="formPro.state == true">
                            <span class="badge bg-success ms-1"
                              ><strong>ACTIVO</strong></span
                            >
                          </h5>
                          <h5 v-else>
                            <span class="badge bg-danger ms-1"
                              ><strong>INACTIVO</strong></span
                            >
                          </h5>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div>
                          <p class="text-muted ">Proveedor</p>
                          <h5 class="font-size-15">{{ formPro.proveedor }}</h5>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted ">No. Orden</p>
                          <h5 class="font-size-15">{{ formPro.no_orden }}</h5>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted ">Total</p>
                          <h5 class="font-size-15">
                            {{ money(formPro.total) }}
                          </h5>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted ">Usuario que Autoriza</p>
                          <h6 v-if="formPro.user != ''" class="font-size-15">
                            {{ formPro.user }}
                          </h6>
                          <h6 v-else class="font-size-15">Sin autorizar</h6>
                        </div>
                      </div>
                    </div>
                    <div class="row">                     
                    </div>
                  </div>                 
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card" style="margin-bottom: 0%;">
          <div class="card-body" style="padding-top:0%;padding-bottom:0%;">
            <h4 class="card-title" style="margin-bottom: 0%;">Listado de Existencias</h4>         
            <!-- Table -->
            <Loader :loading="loadingtable">
              <vuetable
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :api-mode="false"
                :fields="fields"
                :data="detalleorden"
              >
                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado_detalle == true">
                    <span class="badge bg-success ms-1"
                      ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                      ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
                <div slot="subtotal" slot-scope="props">
                  {{ money(props.rowData.subtotal_compra) }}
                </div>
                <div slot="precio_compra" slot-scope="props">
                  {{ money(props.rowData.precio_compra) }}
                </div>
                <div slot="presentaciones" slot-scope="props">
                  {{ props.rowData.stock.presentacione.nombre_presentacion }}
                </div>
              </vuetable>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
